/**
 * Single source for both the desktop megamenu and the mobile drawer, so the two
 * can never drift apart.
 *
 * Testimonial / FAQ / Blog are scroll anchors into landing sections — the comp
 * has no separate pages for them. "Case Studies" appears in the comp's About
 * menu but has no frame at all, so it is omitted rather than linked to a 404.
 */
export const navItems = [
  { label: 'Home', to: '/' },
  {
    label: 'About',
    children: [
      { label: 'Solutions', to: '/solutions' },
      { label: 'User Roles', to: '/user-roles' },
      { label: 'Product Tour', to: '/product-tour' },
      { label: 'Industries We Serve', to: '/industries' },
      { label: 'Benefits Calculator', to: '/benefits-calculator' },
    ],
  },
  { label: 'Features', to: '/#features' },
  { label: 'Testimonial', to: '/#testimonials' },
  { label: 'FAQ', to: '/faqs' },
  { label: 'Blog', to: '/#articles' },
];

export const footerColumns = [
  {
    title: 'Company',
    links: [
      { label: 'About Us', to: '/#about' },
      { label: 'Features', to: '/#features' },
      { label: 'Service', to: '/solutions' },
      { label: 'Testimonials', to: '/#testimonials' },
      { label: 'Contact Us', to: '/contact' },
    ],
  },
  {
    title: 'Resources',
    links: [
      { label: 'Help Center', to: '/contact' },
      { label: 'FAQ', to: '/faqs' },
      { label: 'Privacy Policy', to: '/privacy' },
      { label: 'Terms & Conditions', to: '/terms' },
    ],
  },
  {
    title: 'Solutions',
    links: [
      { label: 'Hotels', to: '/solutions#hotels' },
      { label: 'Restaurants', to: '/industries#restaurants' },
      { label: 'Event Venues', to: '/solutions#events' },
      { label: 'Residential Complexes', to: '/industries' },
      { label: 'Shopping Centers', to: '/industries#malls' },
      { label: 'Hospitals', to: '/industries' },
    ],
  },
];
